import React, { useEffect } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Shared shell for standalone pages (About, Careers, FAQ, Support, etc.).
// Handles the fixed-header offset, scroll-to-top on mount, and a consistent
// centered page hero, then renders page content as children.
const PageLayout = ({ eyebrow, title, subtitle, maxWidth, children }) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{
            paddingTop: Appearance.layout.headerOffset(),
            backgroundColor: Appearance.colors.white,
            minHeight: '72vh',
        }}>
            <div style={{
                maxWidth: maxWidth || Appearance.layout.readableWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
            }}>
                <div style={{ textAlign: 'center', marginBottom: Utils.isMobile() ? 40 : 56 }}>
                    {eyebrow && (
                        <span style={{ ...Appearance.textStyles.label(), display: 'block', marginBottom: 14 }}>
                            {eyebrow}
                        </span>
                    )}
                    <h1 style={{ ...Appearance.textStyles.heroHeading({ fontSize: Utils.isMobile() ? 34 : 46 }), textWrap: 'balance' }}>
                        {title}
                    </h1>
                    {subtitle && (
                        <p style={{ ...Appearance.textStyles.sectionSubheading(), margin: '18px auto 0' }}>
                            {subtitle}
                        </p>
                    )}
                </div>
                {children}
            </div>
        </div>
    );
};

export default PageLayout;
